import { useEffect } from 'react'
import { useState } from 'react'
import { post } from '../../services/api'
import mmCoinImagem from '../../assets/img/mmcoin.png'

function CardMMCoins({ idVendedor, changeVendedor, changeMesAno }) {
    useEffect(() => {
        getDados();
    }, [idVendedor]);

    useEffect(() => {
        setSaldo(0);
    }, [changeVendedor]);

    useEffect(() => {
        setSaldo(0);
    }, [changeMesAno]);

    const [saldo, setSaldo] = useState(0);

    async function getDados() {

        if (idVendedor) {
            const tokenUsuarioLogado = localStorage.getItem('token');
            const requisicao = { vendedor: idVendedor, tokenUsuarioLogado: tokenUsuarioLogado };

            const response = await post('vendedores/mmcoins', requisicao);

            if (response.status === 'success') {
                setSaldo(response.data.saldo);
            }
        }
    }

    function abrirSiteMMCoins() {
        window.open('https://mmcoins.lojasmm.com.br/');
    }

    function formatarValor(valor) {
        try {
            return  valor.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
        } catch (error) {
            console.error('Erro:', error.message);
        }
    }

    return (
        <div className="grid grid-cols-9 grid-rows-1 relative">
            <div className="col-span-9 md:col-span-3 bg-gradient-to-b from-white to-gray-c8 text-center font-bold text-[22px] text-gray-c3 py-4 px-6 grid z-10 shadow-animal rounded-tr-[10px] md:rounded-tr-none">
                <div className="self-center">
                    <img src={mmCoinImagem} alt="Imagem" className="object-contain aspect-[3/4] max-w-full inline-block" />
                    
                </div>
            </div>
            <div className="col-span-9 md:col-span-6 bg-gray-c4 px-4 pb-4 pt-[22px] grid rounded-tr-none md:rounded-tr-[10px]">
                <div className="">
                    <p className="font-light text-gray-c5 text-sm leading-none pb-3">MM Coins</p>
                    <h4 className="font-bold text-gray-c5 text-lg leading-none"><span className="text-4xl uppercase inline-block md:block pt-0 md:pt-1">{formatarValor(saldo)}</span></h4>
                </div>
                <div className="text-gray-c3 font-mulish font-medium text-[15px]">
                    <p className="">Status: Clique em visualizar mais detalhes para ver informações sobre suas MM Coins</p>
                </div>
            </div>
            <div className="col-span-9">
                <button
                    onClick={() => abrirSiteMMCoins()}
                    className="rounded-b-[10px] w-full text-center inline-block bg-gradient-to-b from-green-c3 to-green-c4 py-[10px] font-medium text-base text-white leading-none"
                >
                    Visualizar mais detalhes
                </button>
            </div>
        </div>
    );
}

export default CardMMCoins